// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1ZquY","actionsCol":"EnrolledClinics_actionsCol__3FNJu"};